"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberUtils = void 0;
const lodash_1 = __importDefault(require("lodash"));
const intlFormatNumber = (value, maximumFractionDigits = 0, thousandsSeparator = "", minimumFractionDigits = 0) => {
    const parts = Intl.NumberFormat('en-US', { maximumFractionDigits: maximumFractionDigits, minimumFractionDigits: minimumFractionDigits }).formatToParts(value);
    lodash_1.default.each(parts, part => {
        switch (part.type) {
            case "group": {
                part.value = thousandsSeparator;
                break;
            }
            case "decimal": {
                part.value = ".";
                break;
            }
        }
    });
    return parts.map(v => v.value).join("");
};
/**
 * Format a number and return a string based on passed number of fraction digits.
 * Thousands separator is space " "
 * @param {bigint | number} value
 * @param {number | 0} maximumFractionDigits maximum number of fraction digits
 * @param {number | 0} minimumFractionDigits minimum number of fraction digits
 * @return Formatted number
 * @example having value `9999999.6666` and decimals `3` will output string `"9 999 999.667"`
 */
const formatNumericValue = (value, maximumFractionDigits = 0, minimumFractionDigits = 0) => {
    return intlFormatNumber(value, maximumFractionDigits, " ", minimumFractionDigits);
};
const numericCompare = (a, b) => {
    return a < b ? -1 :
        a > b ? 1 :
            0;
};
exports.NumberUtils = {
    formatNumericValue: formatNumericValue,
    numericCompare: numericCompare,
};
